export const OAuthSettings = {
  appId: 'd5c1bd0a-1f99-44db-b00a-f282b70583b8', 
  // mylifewell account
  scopes: [
    "contacts.read",
  ]
};
